import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const surveysEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-surveys", jiraSpaEntry: "async-servicedesk-surveys" */ './src/ui/SurveysPage'
			),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			context,
		},
	}),
});
